import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base-service';
import { HttpClient } from '@angular/common/http';
import { SearchRequest } from './requests/search-request';
import { Observable } from 'rxjs';
import { ApiResponse, ListResponse } from './responses/api-response';
import { PartyEventProductResponse } from './responses/PartyEventProduct/party-event-product-response';
import { PartyEventsProductUpdateRequest } from '@portal/api/requests/party-events-products/party-events-product-update-request';
import { Guid } from 'guid-typescript';
import { PartyEventsProductAddRequest } from '@portal/api/requests/party-events-products/party-events-product-add-request';
import {StorageService} from "@portal/shared/services/storage.service";
import {PartySelectedService} from "@portal/shared/services/party-selected.service";
import {OrganizationType} from "@portal/api/enums/organization-type";

@Injectable({
    providedIn: 'root'
})

export class PartyEventProductsService extends ApiBaseService {
    constructor(
        public http: HttpClient,
        private _storageService: StorageService,
        private _partySelectedService: PartySelectedService) {
        super(http);
    }

    add(obj: PartyEventsProductAddRequest): Observable<ApiResponse<string>> {
        return this.post<ApiResponse<string>, PartyEventsProductAddRequest>(obj, this.getBaseRoute() + '/add');
    }

    update(obj: PartyEventsProductUpdateRequest): Observable<ApiResponse<string>> {
        return this.put<ApiResponse<string>, PartyEventsProductUpdateRequest>(obj, this.getBaseRoute() + '/update');
    }

    getFormEdit(productId: string): Observable<ApiResponse<PartyEventsProductUpdateRequest>> {
        return this.get<ApiResponse<PartyEventsProductUpdateRequest>>(this.getBaseRoute() + `/form/edit/${productId}`);
    }

    listByEvent(obj: SearchRequest, eventId: Guid, barId: Guid): Observable<ApiResponse<ListResponse<PartyEventProductResponse[]>>> {
        return this.post<ApiResponse<ListResponse<PartyEventProductResponse[]>>, SearchRequest>(
            obj,
            this.getBaseRoute() + `/listallbyevent?eventId=${eventId}&barId=${barId}`
        );
    }

    deleteProduct(id: Guid): Observable<ApiResponse<boolean>> {
        return this.deleteBase<ApiResponse<boolean>>(`${this.getBaseRoute()}/${id}`);
    }

    reorder(ids: string[]): Observable<ApiResponse<boolean>> {
        return this.put<ApiResponse<boolean>, { ids: string[] }>({ ids }, `${this.getBaseRoute()}/reorder`);
    }

    importFromEvent(request: { sourceEventId: string; sourceBarId?: string | null; targetEventId: string; targetBarId: string }): Observable<ApiResponse<{ importedCount: number; withInventoryCount: number }>> {
        return this.post(request, `${this.getBaseRoute()}/import-from-event`);
    }

    private getBaseRoute(): string {
        const orgId = this.getOrgId();
        const partyId = this.getPartyId();
        if (this.isOrgScope() || !partyId) {
            return `orgs/${orgId}/events/products`;
        }
        return `orgs/${orgId}/parties/${partyId}/events/products`;
    }

    private getOrgId(): Guid {
        return this._storageService.getOrg()?.id;
    }

    private getPartyId(): Guid {
        return this._partySelectedService.getPartyId() ?? this._storageService.getParty()?.id;
    }

    private isOrgScope(): boolean {
        return this._storageService.getOrg()?.type === OrganizationType.Association;
    }
}
